import { render, staticRenderFns } from "./matchingReviews.vue?vue&type=template&id=3189819b"
import script from "./matchingReviews.vue?vue&type=script&lang=js"
export * from "./matchingReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports